import {config as accountsConfig} from './Accounts';
import {config as pspindexConfig} from './PSPIndexes';
import {config as checkboxConfig} from './Checkbox';
import {config as addedConfig} from './Added';

export default (labels, handleChange) => [
	checkboxConfig(labels, handleChange),
	accountsConfig(labels),
	pspindexConfig(labels),
	addedConfig()
];
